import * as MutationTypes from '../mutation-types'
import axios from 'axios'
import config from '../../config.js'

const state = {
  activeChat: {},
  myChats: [],
  gettingChatRoom: false,
  sendingMessage: false,
  myAvatar: '',
}

const mutations = {
  [MutationTypes.SET_CHATROOMS](state, { rooms }) {
    state.myChats = rooms
  },
  [MutationTypes.SET_CHATROOM](state, room) {
    state.activeChat = room.room
  },
  [MutationTypes.SEND_MESSAGE](state, message) {
    state.activeChat.messages.push(message.message)
  },
}

const getters = {
  appHasRoom(state, getters, rootState) {
    return rootState.workingApplication.id
      ? rootState.workingApplication.applicationChatroom
        ? rootState.workingApplication.applicationChatroom.communicationActive
        : false
      : false
  },
  myAvatar(state) {
    return state.myAvatar
  },
  avatars() {
    return [
      { id: 1, label: 'whiteKing' },
      { id: 2, label: 'whiteQueen' },
      { id: 3, label: 'whiteBishop' },
      { id: 4, label: 'whitePone' },
      { id: 5, label: 'whiteRook' },
      { id: 6, label: 'whiteKnight' },
    ]
  },
  haveNewMessages(state) {
    return !!state.myChats.new_messages
  },
  newMessagesPerRoom(state) {
    return !!state.myChats.new_messages
  },
  sendingMessage(state) {
    return state.sendingMessage
  },
  gettingChatRoom(state) {
    return state.gettingChatRoom
  },
  activeChat(state) {
    return state.activeChat
  },
  myChats(state) {
    return state.myChats
  },
  privateChats(state) {
    return [state.myChats]
  },
}

const actions = {
  SEND_MESSAGE: function({ commit, dispatch, state }, message) {
    state.sendingMessage = true
    const chatId = message.chatId
    delete message.chatId
    let p = axios
      .put(`${config.BASE_URL}/external/chatrooms/${chatId}/message`, {
        message,
      })
      .then(
        response => {
          state.sendingMessage = false
          commit(MutationTypes.SEND_MESSAGE, { message: response.data.data })
          return response.data.data
        },
        err => {
          state.sendingMessage = false
          dispatch('BACKEND_ERROR_NOTIFY', err)
          return err
        }
      )
    return p
  },
  GET_CHATROOM: function(
    { commit, dispatch, state },
    { id, page, perPage, appId }
  ) {
    state.gettingChatRoom = true
    let p = axios
      .get(
        `${
          config.BASE_URL
        }/external/chatrooms/${id}?page=${page}&per_page=${perPage}${
          appId ? '&app_id=' + appId : ''
        }`
      )
      .then(
        response => {
          state.gettingChatRoom = false
          commit(MutationTypes.SET_CHATROOM, { room: response.data.data })
          return response.data.data
        },
        err => {
          state.gettingChatRoom = false
          dispatch('BACKEND_ERROR_NOTIFY', err)
        }
      )
    return p
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
}
